import { Component } from '@angular/core';

@Component({
  selector: 'app-horarios',
  templateUrl: './horarios.component.html',
  styleUrls: ['./horarios.component.scss']
})
export class HorariosComponent {
  busqueda = '';
  especialidadSeleccionada = '';
  sedeActiva = 'San Luis';
  busquedaAplicada = '';
  especialidadAplicada = '';

  readonly grupos = [
  {
    "sede": "San Luis",
    "especialidad": "Clínica Médica",
    "profesionales": [
      "Sosa María Cecilia",
      "Marsicano Luis",
      "Ferreyra Sergio",
      "Gómez Miranda Candela",
      "Franck Alejandra",
      "Marquéz Melisa"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Cardiología",
    "profesionales": [
      "Trujillo Liliana",
      "Cangiano Maria Cecilia",
      "Romero Sandra"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Gastroenterología",
    "profesionales": [
      "Rossi Mario"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Ginecología",
    "profesionales": [
      "Garrido Elena",
      "Simón Julio"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Obstetricia",
    "profesionales": [
      "Arias"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Kinesiología",
    "profesionales": [
      "Cortéz Ariel",
      "Majul Érika"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Diabetología",
    "profesionales": [
      "Carreño Nancy",
      "Pereyra Sanchez"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Ecografía",
    "profesionales": [
      "Cano Liliana"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Fonoaudiologia",
    "profesionales": [
      "Chanampa Stella"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Clínica Médica Nefrológica",
    "profesionales": [
      "Gomez Miranda Candela (Nefrología)"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Neurología",
    "profesionales": [
      "Abrahín José"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Nutricionista",
    "profesionales": [
      "Mendoza Silvia",
      "Romina Cejas"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Odontología",
    "profesionales": [
      "Balladore Camila",
      "Arroyuelo Florencia",
      "Amieva Martín",
      "Fumero Victoria",
      "Magallanes Cecilia"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Otorrinolaringología",
    "profesionales": [
      "Tobares Néstor"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Pediatría",
    "profesionales": [
      "Vergés Eduardo"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Oftamología",
    "profesionales": [
      "Battistelli Cecilia"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Psicología",
    "profesionales": [
      "Montivero Federico",
      "Rodríguez Galende Laura",
      "Quevedo Jorge",
      "Castillo"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Psiquiatría",
    "profesionales": [
      "Samperisi Gabriel"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Traumatología",
    "profesionales": [
      "Pascual Eduardo"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Urología",
    "profesionales": [
      "Vilche Juan Manuel"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Radiología",
    "profesionales": [
      "Guidobaldi Adriana Esther"
    ]
  },
  {
    "sede": "San Luis",
    "especialidad": "Enfermería",
    "profesionales": [
      "Gonzalez Caravaca Cynthia",
      "Ledesma Yamila"
    ]
  },
  {
    "sede": "Villa Mercedes",
    "especialidad": "Clínica Médica",
    "profesionales": [
      "Dr. José Igancio Ojeda"
    ]
  },
  {
    "sede": "Villa Mercedes",
    "especialidad": "Odontología",
    "profesionales": [
      "Dra. María Eugenia Sosa",
      "Dra. Cintia Mediza",
      "Dra. Norma Colomer"
    ]
  },
  {
    "sede": "Villa Mercedes",
    "especialidad": "Fisioterapeuta",
    "profesionales": [
      "Lic. Walter Zalazar"
    ]
  },
  {
    "sede": "Villa Mercedes",
    "especialidad": "Flebología",
    "profesionales": [
      "Dr. Jorge Martini"
    ]
  },
  {
    "sede": "Villa Mercedes",
    "especialidad": "Diabetología / Gerontología",
    "profesionales": [
      "Dra. Marcela Navarro de la Fuente"
    ]
  }
];

  readonly especialidades = Array.from(new Set(this.grupos.map(grupo => grupo.especialidad)))
    .sort((a, b) => a.localeCompare(b, 'es'));

  get filtrosActivos(): boolean {
    return !!this.busquedaAplicada.trim() || !!this.especialidadAplicada;
  }

  private normalizar(texto: string): string {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }

  coincideProfesional(nombre: string): boolean {
    const profesional = this.normalizar(nombre);
    return this.normalizar(this.busquedaAplicada).split(/\s+/).every(palabra => profesional.includes(palabra));
  }

  hayResultados(indice: number): boolean {
    const grupo = this.grupos[indice];
    return (!this.especialidadAplicada || grupo.especialidad === this.especialidadAplicada)
      && grupo.profesionales.some(nombre => this.coincideProfesional(nombre));
  }

  hayResultadosEnSede(): boolean {
    return this.grupos.some((grupo, indice) => grupo.sede === this.sedeActiva && this.hayResultados(indice));
  }

  buscar(): void {
    this.busquedaAplicada = this.busqueda;
    this.especialidadAplicada = this.especialidadSeleccionada;
  }
}
